import React from "react";
import { Route, Routes } from "react-router-dom";

import AppLayout from "./components/layouts/appLayout/AppLayout";

import { LandingPage, ErrorPage } from "./pages";

const App = () => {
  return (
    <AppLayout>
      <Routes>
        <Route path="/" element={<LandingPage />} />

        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </AppLayout>
  );
};

export default App;
